import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <section className="contact" id="contact">
      <h2>Let’s Design Together</h2>
      <p className="subtitle">
        Lorem ipsum dolor sit amet consectetur. Tristique amet sed massa nibh
        lectus netus in.
      </p>

      <div className="contact-box">
        <input type="email" placeholder="Enter Your Email" />
        <button>Contact Me</button>
      </div>
    </section>
  );
};

export default Contact;
